angular.module('qkr.refund').controller('refundTransController', ($scope, $uibModalInstance, gettextCatalog, refundService, trans) => {
    $scope.trans = trans;
    $scope.reason = {
        customReason: ''
    };
    $scope.refundTransCommand = {
        transId: trans.id,
        refundReason: null,
        refundPassword: null,
        merchantLocId: trans.merchantLocId
    };
    $scope.defaultRefundReasons = [
        {text: 'Closed'},
        {text: 'Out of Stock'},
        {text: 'Custom'}
    ];

    $scope.confirm = function() {
        $scope.errorMessage = null;

        const isCustom = $scope.refundTransCommand.refundReason === 'Custom';

        if (isCustom) {
            $scope.refundTransCommand.refundReason = $scope.reason.customReason;
        }

        if (!isCommandValid()) {
            if (isCustom) {
                $scope.refundTransCommand.refundReason = 'Custom';
            }
            return;
        }

        $scope.loading = true;

        refundService.refundTrans($scope.refundTransCommand).then((response) => {
            $scope.loading = false;

            $uibModalInstance.close({
                message: 'ok',
                refundedTransaction: response
            });
        }).catch((reason) => {
            $scope.loading = false;
            $scope.errorMessage = reason.message;
        });
    };

    $scope.cancel = function() {
        $scope.errorMessage = null;
        $uibModalInstance.close('cancel');
    };

    var isCommandValid = function() {
        if (!$scope.refundTransCommand.refundReason) {
            $scope.errorMessage = gettextCatalog.getString('Please enter the reason for this refund');
            return false;
        }

        if (!$scope.refundTransCommand.refundPassword) {
            $scope.errorMessage = gettextCatalog.getString('Please enter your refund password');
            return false;
        }

        return true;
    };
});



// WEBPACK FOOTER //
// ./src/refund/controllers/modal/refund.trans.controller.js